const fillFormNoticePopUpTranslations = {
  title: "Kindly Fill Out Your Form",
  description:
    "Please Fill Out Your Form, In Order To Get Your Customized Program.",
  action: "Fill Form",
};

export default fillFormNoticePopUpTranslations;
